import { render, staticRenderFns } from "./OrganizationMdtDiseaseDetail.vue?vue&type=template&id=ab747e32&scoped=true"
import script from "./OrganizationMdtDiseaseDetail.vue?vue&type=script&lang=js"
export * from "./OrganizationMdtDiseaseDetail.vue?vue&type=script&lang=js"
import style0 from "./OrganizationMdtDiseaseDetail.vue?vue&type=style&index=0&id=ab747e32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab747e32",
  null
  
)

export default component.exports